import React, {Component} from 'react';
import {Card, CardBody, CardTitle, Row} from 'reactstrap';
import {Colxx} from "../../../../components/common/CustomBootstrap";
import NotificationStats from "../../../../containers/NotificationStats";
import {withTranslation} from "react-i18next";
import Api from '../../../../services/Api';

class View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    const {match} = this.props;
    const {id} = match.params;
    try {
      const {data} = await Api.invoke('GET', `/v2/admin-ui/notifications/stat`, null, {
        params: {id},
      });
      this.setState({
        status: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  render() {
    const {status} = this.state;
    const {t, match} = this.props;
    const {id} = match.params;
    return (
      <Row>
        <Colxx xxs="12">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary mb-5">
                {`${t('Notification Stats')} (${id})`}
              </CardTitle>
              <NotificationStats data={status}/>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(View);
